const sakuraSystem = {
  emitters: [
    {
      id: 1,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.75, 0],
          [0.85, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [0.1, 0.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.001,
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/petal.png',
        },
        scale: {
          type: 'range',
          value: [0.1, 0.55],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
    {
      id: 2,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.2, 0.1],
          [-0.2, 1],
        ],
      },
      speed: {
        type: 'range',
        value: [0.1, 0.7],
      },
      rate: {
        type: 'float',
        value: 75,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.001,
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/petal.png',
        },
        scale: {
          type: 'range',
          value: [0.1, 0.55],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
    {
      id: 3,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.75, 0],
          [0.85, 0],
        ],
      },
      layer: {
        type: 'string',
        value: 'background',
      },
      speed: {
        type: 'range',
        value: [0.1, 0.7],
      },
      rate: {
        type: 'float',
        value: 125,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'image',
        },
        wobble: {
          type: 'range',
          value: [0, 10],
        },
        gravity: {
          type: 'float',
          value: 0.001,
        },
        image: {
          type: 'string',
          value: 'https://sharefolio-public.s3.amazonaws.com/petal.png',
        },
        scale: {
          type: 'range',
          value: [0.1, 0.55],
        },
        rotation: {
          type: 'range',
          value: [0, 6.283],
        },
        rotationRate: {
          type: 'range',
          value: [-0.01, 0.01],
        },
        drag: {
          type: 'vector',
          value: [0.1, 0],
        },
      },
    },
  ],
  effects: [
    {
      type: 'impulse',
      emitters: [1, 2, 3],
      energy: 'above',
      data: {
        direction: -0.3,
        amount: 0.02,
      },
    },
  ],
}

export default sakuraSystem
